import { Typography } from '@pvh-components/typography';
import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import Icon from '../Icon';
import styles from './benefitsPopupHeader.module.css';
import useBenefitsPopup from './useBenefitsPopup';

export interface BenefitsPopupHeaderProps extends WithTestId {
  title: string;
}

const BenefitsPopupHeader = ({
  title,
  dataTestIdPrefix,
}: BenefitsPopupHeaderProps) => {
  const toggle = useBenefitsPopup();

  return (
    <header
      className={styles.benefitsPopupHeader}
      data-testid={toKebabCase(dataTestIdPrefix, 'benefitsHeader')}
    >
      <div
        className={styles.benefitsPopupClose}
        data-testid={toKebabCase(
          dataTestIdPrefix,
          'benefitsHeader',
          'closeButton'
        )}
      >
        <Icon size={18} name="cross" onClick={toggle} />
      </div>
      <Typography variant="h2">{title}</Typography>
    </header>
  );
};

export default BenefitsPopupHeader;
